import { resourceReducer, getResources } from 'redux-resource';
import { getPagination } from 'common/Pagination/selectors';

export default resourceReducer('purchases');

export const getCurrentPurchase = (state) => {
  const overdue = getResources(state, (purchase) => {
    return ['overdue', 'arranged'].includes(purchase.status);
  });
  overdue.sort((a, b) => {
    if (a.purchase_date > b.purchase_date) {
      return -1;
    }
    else if (a.purchase_date === b.purchase_date) {
      return 0;
    }
    else if (a.purchase_date < b.purchase_date) {
      return 1;
    }

    return 0;
  });
  if (overdue && overdue.length > 0) {
    return overdue[0];
  }
  else {
    return null;
  }
}

export const getPurchase = (state, id) => state.resources[id];

export const getGroupedLineItems = (state, purchaseId) => {
  const purchase = state.resources[purchaseId];
  if (!purchase) { return [] }

  const quick = {};
  const bypassed = {};
  const sprint = {};
  const other = [];

  purchase.line_items.forEach(item => {
    if (item.subscription) {
      sprint[item.subscription] = sprint[item.subscription] || [];
      sprint[item.subscription].push(item);
    } else if (item.bypassed_subscription) {
      bypassed[item.bypassed_subscription] = bypassed[item.bypassed_subscription] || [];
      bypassed[item.bypassed_subscription].push(item);
    } else if (item.quick_subscription) {
      quick[item.quick_subscription] = quick[item.quick_subscription] || [];
      quick[item.quick_subscription].push(item);
    } else {
      other.push(item);
    }
  });

  const groupedLineItems = [];

  for (const [id, lineItems] of Object.entries(sprint)) {
    groupedLineItems.push({
      sprintSubscription: parseInt(id),
      lineItems
    });
  }

  for (const [id, lineItems] of Object.entries(bypassed)) {
    groupedLineItems.push({
      bypassedSubscription: parseInt(id),
      lineItems
    });
  }

  for (const [id, lineItems] of Object.entries(quick)) {
    groupedLineItems.push({
      quickSubscription: parseInt(id),
      lineItems
    });
  }

  other.length > 0 && groupedLineItems.push({
    other: true,
    lineItems: other
  });

  return groupedLineItems;
};

export const getPurchaseHistory = (state, page = 1) => getResources(state, `userHistory${page}`);

export const getHistoryPagination = (state, page) => getPagination(state, `getHistory${page}`);
export const getOverduePurchases = (state) => getResources(state, p => p.status === 'overdue');

export const getGetAllError = (state) => state.requests.getAll && state.requests.getAll.error;
export const getFilteredPurchase = (state, lineItemId) => getResources(state, purchase => {
  return purchase.line_items.find( lineItem => lineItem.id === lineItemId );
})
